"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusBar = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".cc266f06d{display:block}.cd3a8a128{display:grid;grid-template-columns:1fr fit-content(100%);grid-gap:1rem;grid-gap:1rem;grid-gap:1rem;gap:1rem;margin-bottom:.625rem;align-items:center}.cae714c48{font-size:.875rem;font-weight:400;line-height:1rem;color:var(--color-flomni-gray-70)}.c634ccabd{font-size:.875rem;font-weight:400;line-height:1rem;color:var(--color-flomni-gray-90)}.ce767506c{height:.5rem;position:relative}.c2a794820{transition:background var(--animation-timing-def) ease;position:absolute;top:0;left:0;right:0;bottom:0;border-radius:.125rem}.c1911c5d4{transition:all var(--animation-timing-def) ease;transition-property:width,background;position:absolute;top:0;left:0;bottom:0;border-radius:.125rem}.c8375bf1e .c2a794820{background:var(--color-flomni-gray-40)}.c8375bf1e .c1911c5d4{background:var(--color-flomni-rose-70)}.c2ead52c4 .c2a794820{background:var(--color-flomni-blue-10)}.c2ead52c4 .c1911c5d4{background:var(--color-flomni-blue-70)}.c12f678ee .c2a794820{background:var(--color-flomni-bg-3)}.c12f678ee .c1911c5d4{background:var(--color-flomni-green-70)}.cde573922 .c2a794820{background:var(--color-flomni-rose-10)}.cde573922 .c1911c5d4{background:var(--color-flomni-rose-70)}");
var styles = {
  root: 'cc266f06d',
  header: 'cd3a8a128',
  title: 'cae714c48',
  persents: 'c634ccabd',
  status: 'ce767506c',
  bg: 'c2a794820',
  front: 'c1911c5d4',
  '--color-grey': 'c8375bf1e',
  '--color-usual': 'c2ead52c4',
  '--color-success': 'c12f678ee',
  '--color-warning': 'cde573922'
};

var StatusBar = function StatusBar(props) {
  var classes = props.classes,
      children = props.children,
      min = props.min,
      max = props.max,
      value = props.value,
      isValueVisible = props.isValueVisible;
  var cn = (0, _useStyles.useStyles)(styles, classes);

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      node = _useState2[0],
      setNode = _useState2[1];

  var elRef = (0, _react.useCallback)(function (node) {
    return setNode(node);
  }, []);
  var persents = (0, _react.useMemo)(function () {
    var nMin = 0;
    var nMax = 100;
    var result = (value - min) * (nMax - nMin) / (max - min) + nMin;
    return Number.isFinite(result) ? Math.round(result) : nMin;
  }, [max, min, value]);
  var color = (0, _react.useMemo)(function () {
    var MAP = [{
      min: 0,
      max: 0,
      color: 'grey'
    }, {
      min: 1,
      max: 50,
      color: 'warning'
    }, {
      min: 51,
      max: 90,
      color: 'usual'
    }, {
      min: 91,
      max: 100,
      color: 'success'
    }];
    var item = MAP.find(function (_ref) {
      var min = _ref.min,
          max = _ref.max;
      return persents >= min && persents <= max;
    });
    return item ? item.color : 'warning';
  }, [persents]);
  (0, _react.useEffect)(function () {
    if (!node) return;
    node.style.width = "".concat(persents, "%");
  }, [node, persents]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.color[color])
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.header
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.title
  }, children), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.persents
  }, /*#__PURE__*/_react.default.createElement("span", null, persents, "%"), isValueVisible ? /*#__PURE__*/_react.default.createElement("span", null, " (", Math.round(value), ")") : null)), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.status
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.bg
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: elRef,
    className: cn.front
  })));
};

exports.StatusBar = StatusBar;
StatusBar.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,
  min: _propTypes.number,
  max: _propTypes.number.isRequired,
  value: _propTypes.number.isRequired,
  isValueVisible: _propTypes.bool,

  /* styling modificators */

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
StatusBar.defaultProps = {
  classes: {},
  min: 0,
  isValueVisible: false
};